/**
 * Created by sagardesai on 28/06/18.
 */

import * as types from "../actions/types/index";
import { setInitialState } from "../util/utility";

const INITIAL_STATE = setInitialState({
  broadcasterDetail: null,
  similarBroadcasters: null,
  trendingBroadcasters: null,
  broadcastDetail: null,
});

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.BROADCASTER_DETAIL_REQUEST:
    case types.BROADCAST_DETAIL_REQUEST:
    case types.SIMILAR_BROADCASTER_REQUEST:

      return {
        ...state,
        isFetching: true,
      };
    case types.BROADCAST_DETAIL_RECEIVE:
      return {
        ...state,
        isFetching: false,
        isSuccess: true,
        broadcastDetail: action.payload,
      };

    case types.BROADCAST_DETAIL_FAILURE:

      return {
        ...state,
        isFetching: false,
        isError: true,
        broadcastDetail: {
          error: action.payload.response.error,
        },
      };
    case types.RESET_BROADCAST_DETAIL:
      return {
        ...state,
        broadcastDetail: action.payload,
      };

    case types.BROADCASTER_DETAIL_RECEIVE:
      return {
        ...state,
        isFetching: false,
        isSuccess: true,
        broadcasterDetail: action.payload,
      };

    case types.BROADCASTER_DETAIL_FAILURE:
      return {
        ...state,
        isFetching: false,
        isError: true,
        broadcasterDetail: {
          error: action.payload.response.error,
        },
      };
    case types.RESET_BROADCASTER_DETAIL:
      return {
        ...state,
        broadcasterDetail: action.payload,
      };

    case types.SIMILAR_BROADCASTER_RECEIVE:
      return {
        ...state,
        isFetching: false,
        isSuccess: true,
        similarBroadcasters: action.payload,
      };
    case types.SIMILAR_BROADCASTER_FAILURE:
      return {
        ...state,
        isFetching: false,
        isError: true,
        similarBroadcasters: action.payload.error,
      };
    case types.RESET_SIMILAR_BROADCASTER:
      return {
        ...state,
        similarBroadcasters: action.payload,
      };
    case types.TRENDING_BROADCASTERS_LIST_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case types.TRENDING_BROADCASTERS_LIST_RECEIVE:
      return {
        ...state,
        isFetching: false,
        isSuccess: true,
        trendingBroadcasters: action.payload,
      };
    case types.TRENDING_BROADCASTERS_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isError: true,
        trendingBroadcasters: action.payload.error,
      };
    case types.RESET_TRENDING_BROADCASTERS_LIST:
      return {
        ...state,
        trendingBroadcasters: action.payload,
      };

    case types.BROADCASTS_LIST_SORT_BY:
      return {
        ...state,
        sortBroadcastBy: action.payload,
      };
    case types.RESET_BROADCASTS_LIST_SORT_BY:
      return {
        ...state,
        sortBroadcastBy: action.payload,
      };
    case types.SET_SEARCH_FOR_BROADCASTER_STATE:
      return {
        ...state,
        performSearch: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
